// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"273f4fa0","286":"0cb0182a"}[chunkId] + ".chunk.css";
};